export default "/static/dashboard/build/app/img/v2/eeaba0c5c8991ad8f7b85a392f1ac9e8.png";